import * as React from 'react';
import { useTheme } from '@emotion/react';
import { motion } from 'motion/react';
import { CloudCodeTask } from './CloudCodeTask';
import { S } from '../styles';
import { StoryScene } from '../story';

interface AppConnectionsArtworkProps {
  scene: StoryScene;
  focusApps: boolean;
  reducedMotion: boolean;
  animateConnections: boolean;
}

export const AppConnectionsArtwork: React.FC<AppConnectionsArtworkProps> = ({
  scene,
  focusApps,
  reducedMotion,
  animateConnections
}) => {
  const theme = useTheme();
  const colors = theme.featureGraph;
  const transition = { duration: reducedMotion ? 0 : 0.7 };
  const reveal = (firstScene: StoryScene) => ({ opacity: scene >= firstScene ? 1 : 0 });
  return (
    <>
      <motion.g initial={false} animate={reveal(StoryScene.MULTIPLE_APPS)} transition={transition}>
        {['M480 430 H427', 'M915 430 H862'].map((path) => (
          <g key={path}>
            <path d={path} fill="none" stroke={colors.cloudService.border} strokeWidth="2" />
            <S.Flow
              d={path}
              running={animateConnections}
              fill="none"
              stroke={colors.cloudService.accent}
              strokeWidth="2"
              strokeDasharray="5 12"
            />
          </g>
        ))}
        <path
          d="M433 425 L427 430 L433 435 M868 425 L862 430 L868 435"
          fill="none"
          stroke={colors.cloudService.accent}
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </motion.g>
      <motion.g initial={false} animate={{ opacity: focusApps ? 1 : 0 }} transition={transition}>
        {[
          'M235 595 V712.5 Q235 732.5 255 732.5 H480',
          'M860 732.5 H1085 Q1105 732.5 1105 712.5 V597',
          'M565 265 V137.5 Q565 117.5 585 117.5 H697.5',
          'M1077.5 117.5 H1190 Q1210 117.5 1210 137.5 V263'
        ].map((path) => (
          <g key={path}>
            <path d={path} fill="none" stroke={colors.cloudService.border} strokeWidth="2" />
            <S.Flow
              d={path}
              running={animateConnections}
              fill="none"
              stroke={colors.cloudService.accent}
              strokeWidth="2"
              strokeDasharray="5 12"
            />
          </g>
        ))}
        <path
          d="M474 727.5 L480 732.5 L474 737.5 M1100 603 L1105 597 L1110 603 M691.5 112.5 L697.5 117.5 L691.5 122.5 M1205 257 L1210 263 L1215 257"
          fill="none"
          stroke={colors.cloudService.accent}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <g transform="translate(480 655)">
          <CloudCodeTask title="Coordinate work" source="Inspection" result="Work order" running={animateConnections} />
        </g>
        <g transform="translate(697.5 40)">
          <CloudCodeTask
            title="Prepare dispatch"
            source="Stock ready"
            result="Assign team"
            running={animateConnections}
          />
        </g>
      </motion.g>
    </>
  );
};
